import { cn } from "@/lib/utils";

/**
 * Pyng mark — "Quiet Luxury": a refined lowercase-p monogram whose bowl is an
 * open circle, with a signal dot closing the gap. The open circle is reaching
 * out; the dot is the person you reach.
 * Kept as PlanetMark internally so existing import sites are undisturbed.
 */
export function PlanetMark({
  size = 32,
  className,
  animated,
}: {
  size?: number;
  className?: string;
  /** Loading state: the bowl stroke travels and the signal dot pulses. */
  animated?: boolean;
}) {
  const px = `${size}px`;
  return (
    <span
      aria-hidden="true"
      className={cn(
        "relative inline-grid place-items-center rounded-[28%] mark-surface shadow-soft overflow-hidden",
        animated && "pyng-loader-mark",
        className,
      )}
      style={{ width: px, height: px }}
    >
      <svg
        viewBox="0 0 40 40"
        width={size}
        height={size}
        className="block"
      >
        {/* p stem — descender */}
        <path
          d="M12.4 12.4 V33.6"
          fill="none"
          stroke="currentColor"
          strokeWidth="3.6"
          strokeLinecap="round"
        />
        {/* bowl — geometric circle, open at the upper right */}
        <circle
          cx="19.9"
          cy="19.9"
          r="7.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="3.6"
          strokeLinecap="round"
          strokeDasharray="37.3 9.8"
          strokeDashoffset="-30"
          className={animated ? "pyng-loader-bowl" : undefined}
        />
        {/* signal dot — the ping closing the gap */}
        <circle
          cx="29"
          cy="11.2"
          r="3.1"
          fill="var(--accent-neon)"
          className={animated ? "pyng-loader-dot" : undefined}
        />
      </svg>
    </span>
  );
}

export default PlanetMark;
